// Valores internos de counterpart_type (wire/BD) — espejo EXACTO de
// UserCounterpartType.OPTIONS_COUNTERPART_TYPES del backend y de los strings
// que emiten los CASE de sql_counterpart_type en los selectores. Son valores
// de matching (user.valid_counterparts, filtro de tipos del clasificador,
// keys de los mapas de este archivo), NO labels: el display se traduce en
// CounterpartTypePill (p.ej. 'Nota de Venta' se muestra "Nota de Ingreso").
// Renombrar uno acá o en el backend sin migrar BD + ambos lados rompe el
// clasificador (regresión e0318fd9 → 81ac651a); los specs fijan el contrato.
export const COUNTERPART_TYPE_VALUES = [
    "Cliente",
    // Ventas/Costos Devengados (plantilla estándar); display "Clientes".
    // Va JUNTO a 'Cliente' a propósito: el import cv desactiva 'Cliente' y
    // activa este tipo por usuario, así que en los filtros se muestra uno en
    // el lugar del otro (el orden acá diverge del choices del backend, donde
    // el orden no gobierna ningún display).
    "clientes-v-cv",
    "Proveedor",
    "Honorario",
    "Trabajador",
    "Internacional",
    "Recibo",
    "Finiquito",
    "Nota de Venta",
];

// Mapeo tipo de contraparte de gastos → obligación que usa el endpoint de
// metadata del drawer de detalle (HeaderClientDetail/BodyClientDetail).
// Proveedor/Cliente caen al bucket "Otros". Compartido por el ranking del
// modal de análisis (BodyExpensesAnalysis) y el atajo de la tabla (GastosTab),
// para no duplicar el mapa.
export const METADATA_OBLIGATION_BY_TYPE = {
    Honorario: "Boleta de Honorarios",
    Trabajador: "remuneracion-clf",
    Internacional: "invoices-clf",
    Recibo: "recibos-clf",
    Finiquito: "finiquitos-clf",
    "Nota de Venta": "notas-venta-clf",
    // La contraparte agrupa 4 obligaciones (venta/costo × normal/NC); la de
    // venta es la representativa para la metadata del drawer.
    "clientes-v-cv": "ventas-cv-clf",
};

export function obligationForType(counterpartType) {
    return METADATA_OBLIGATION_BY_TYPE[counterpartType] || "Otros";
}

// Tipos cuya contraparte usa un RUT placeholder compartido (66666666-6 para
// recibos y notas de venta) — el RUT no identifica a nadie, así que las vistas
// no lo muestran. Compartido por CounterpartTable y ClassifyAccountAttributes.
export const PLACEHOLDER_RUT_COUNTERPART_TYPES = [
    "Recibo",
    "Nota de Venta",
    "clientes-v-cv",
];

export function hasPlaceholderRut(counterpartType) {
    return PLACEHOLDER_RUT_COUNTERPART_TYPES.includes(counterpartType);
}

// Tipos cuya clasificación nace del ARCHIVO de import (Ventas/Costos
// Devengados) y es de SOLO LECTURA en el clasificador (D10 del plan): el
// backend rechaza save_prorate_tree para estos documentos y la UI no ofrece
// edición — corregir = corregir la plantilla y re-subir el mes.
export const READ_ONLY_CLASSIFICATION_TYPES = ["clientes-v-cv"];

export const READ_ONLY_CLASSIFICATION_TOOLTIP =
    "Clasificado por archivo — corrige la plantilla y vuelve a subir el mes.";

export function isReadOnlyClassification(counterpartType) {
    return READ_ONLY_CLASSIFICATION_TYPES.includes(counterpartType);
}
